import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";

//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";

class SellerDashboard extends React.Component {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    return (
      <Fragment>
        <div className="dashboard-wrapper wrapper-90 max-1600">
          <BreadCrumb title={`My Account`} />
          <div className="container-fluid px-0">
            <div className="row">
              <AccountLeftSidebar />
              <div className="col-md-9 col-sm-9 px-0">
                <div className="dashboard-content">
                  <header className="dashboard-heading">
                    <h4 className="dashboard-title">Dashboard</h4>
                  </header>
                  <div className="row">
                    <div className="col-md-4 ">
                      <div className="dashboard-links-list">
                        <div className="dashboard-links">
                          <h4 className="dashboard-column-title">
                            SELLER ACCOUNT
                          </h4>
                          <div className="seller-account-links dashboard-column">
                            <Link to="/seller-orders" className="d-link">
                              <div className="d-link-icon">
                                <i className="dashboard-icons fas fa-cart-plus"></i>
                              </div>
                              <div className="d-link-txt">
                                <span>Orders</span>
                              </div>
                            </Link>
                          </div>
                          <div className="seller-account-links dashboard-column">
                            <Link href="#" target="_blank" className="d-link">
                              <div className="d-link-icon">
                                <i class="dashboard-icons fas fa-gifts"></i>
                              </div>
                              <div className="d-link-txt">
                                <span>Products</span>
                              </div>
                            </Link>
                          </div>
                          <div className="seller-account-links dashboard-column">
                            <Link href="adminmessage.html" className="d-link">
                              <div className="d-link-icon">
                                <i class="dashboard-icons fa fa-envelope"></i>
                              </div>
                              <div className="d-link-txt">
                                <span>Admin Messages</span>
                              </div>
                            </Link>
                          </div>

                          <div className="seller-account-links dashboard-column">
                            <Link
                              to={"/bulk-products-upload"}
                              className="d-link"
                            >
                              <div className="d-link-icon">
                                <i class="dashboard-icons fas fa-cloud-upload-alt"></i>
                              </div>
                              <div className="d-link-txt">
                                <span>Bulk Product Upload</span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 ">
                      <div className="dashboard-links-list">
                        <div className="dashboard-links">
                          <h4 className="dashboard-column-title">
                            SELLER STORE
                          </h4>
                          <div className="seller-store-links dashboard-column">
                            <Link className="d-link">
                              <div className="d-link-icon">
                                <i class="dashboard-icons fas fa-store"></i>
                              </div>
                              <div className="d-link-txt">
                                <span>View Store</span>
                              </div>
                            </Link>
                          </div>
                          <div className="seller-store-links dashboard-column">
                            <Link
                              to={"/seller-store-information"}
                              className="d-link"
                            >
                              <div className="d-link-icon">
                                <i class="dashboard-icons fas fa-store-alt"></i>
                              </div>
                              <div className="d-link-txt">
                                <span>Store Information</span>
                              </div>
                            </Link>
                          </div>

                          <div className="seller-store-links dashboard-column">
                            <Link
                              to={"/membership-packages"}
                              className="d-link"
                            >
                              <div className="d-link-icon">
                                <i class="dashboard-icons fas fa-box-open"></i>
                              </div>
                              <div className="d-link-txt">
                                <span>Membership Packages</span>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default SellerDashboard;
